import Svg, {G, Path, type PathProps, type SvgProps} from 'react-native-svg'

import {COOEY_MARK_PATH} from '#/lib/cooey/mark'
import {useTheme} from '#/alf'

const ratio = 17 / 64

export function LogomarkWithType({
  fill,
  ...rest
}: {fill?: PathProps['fill']} & SvgProps) {
  const t = useTheme()
  const size = parseInt(`${rest.width || 32}`)

  return (
    <Svg
      fill="none"
      viewBox="0 0 136 31"
      {...rest}
      width={size}
      height={Number(size) * ratio}>
      {/*
       * CooeyNet mark centered in the original lockup's box, so callers keep the
       * same footprint. The 24x24 mark is scaled to ~27px and centered.
       */}
      <G transform="translate(54.5 2) scale(1.125)">
        <Path fill={fill || t.atoms.text.color} d={COOEY_MARK_PATH} />
      </G>
    </Svg>
  )
}
